import { APIMethod, fetchData } from "@client";
import { mapKeysToSnakeCase } from "@client/api/utils/fetchApiUtils";

export async function updateRateCardTeamMemberQuery(teamMemberId, data) {
  return await fetchData(
    `/company/rate-card/roles/${teamMemberId}`,
    APIMethod.PATCH,
    {
      isJSONData: true,
      data: mapKeysToSnakeCase(data)
    }
  );
}
